import * as React from "react"
import { ChildrenProps } from "../../../@types/CapioWeb/core"

export interface NewsArchiveFilterContextValue {
	activeOrganisationIds?: number[]
	updateActiveOrganisationIds: (key: number) => void
	activeNewsSubjectIds: number[]
	updateActiveNewsSubjectIds: (key: number) => void
}

export const NewsArchiveFilterContext =
	React.createContext<NewsArchiveFilterContextValue>({
		activeOrganisationIds: [],
		updateActiveOrganisationIds: (key: number) => null,
		activeNewsSubjectIds: [],
		updateActiveNewsSubjectIds: (key: number) => null,
	})

export const NewsArchiveFilterContextProvider: React.FC<ChildrenProps> = (
	props
) => {
	const [activeOrganisationIds, setActiveOrganisationIds] = React.useState([])
	const [activeNewsSubjectIds, setActiveNewsSubjectIds] = React.useState([])

	const updateActiveOrganisationIds = (key: number) =>
		setActiveOrganisationIds(
			activeOrganisationIds.includes(key)
				? activeOrganisationIds.filter((activeKey) => activeKey !== key)
				: [...activeOrganisationIds, key]
		)

	const updateActiveNewsSubjectIds = (key: number) =>
		setActiveNewsSubjectIds(
			activeNewsSubjectIds.includes(key)
				? activeNewsSubjectIds.filter((activeKey) => activeKey !== key)
				: [...activeNewsSubjectIds, key]
		)

	return (
		<NewsArchiveFilterContext.Provider
			value={{
				activeOrganisationIds,
				updateActiveOrganisationIds,
				activeNewsSubjectIds,
				updateActiveNewsSubjectIds,
			}}
		>
			{props.children}
		</NewsArchiveFilterContext.Provider>
	)
}
